import React from "react";
import Card from "./Card";
import Header from "./Header";

function App() {
  return (
    <div className="App">
      <Header />
      <Card
        imgsrc="https://malayalam.samayam.com/photo/msid-85343863,imgsize-1092261/pic.jpg"
        description="Amazon Prime Video"
        title="Pushpa Part 1"
        link="https://www.primevideo.com/detail/0QH32UG7NRSFRGZT78NFD6KED7/ref=atv_hm_hom_1_c_It2HTX_awns_3_1"
      />
      <Card
        imgsrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRzzLM-e8bZKgKrv1Yf8l30ZyY7QjBoQUh-A&usqp=CAU"
        description="Netfix Movie"
        title="Extraction Part 1"
        link="https://www.netflix.com/in/title/80230399"
      />
      <Card
        imgsrc="https://static.toiimg.com/photo/msid-69722017/69722017.jpg?758183"
        description="Netfix Movie"
        title="Artical 15"
        link="https://www.netflix.com/in/title/81154455"
      />
      <Card
        imgsrc="https://static.abplive.com/wp-content/uploads/sites/2/2020/07/31183409/RAH.jpg"
        description="Netfix Movie"
        title="Raat Akeli Hai"
        link="https://www.netflix.com/in/title/81269716"
      />

      <Card
        imgsrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSu0tFtb3Eh3pWFaJzAOYOpZxnqQ4tRTxkknA&usqp=CAU"
        description="Hotstar Movie"
        title="MS Dhoni"
        link="https://www.hotstar.com/in/movies/ms-dhoni-the-untold-story/1770003314"
      />
      <Card
        imgsrc="https://www.pinkvilla.com/files/styles/amp_metadata_content_image/public/jai_bhim_first_look_1_0.jpg"
        description="Amazon Prime Video"
        title="Jai Bhim"
        link="https://www.primevideo.com/detail/0SWGQNS7I3QUVSVKQE0V3Q0O2V/ref=atv_dp_amz_det_c_Iw3Dma_1_2"
      />
      <Card
        imgsrc="https://www.santabanta.com/images/wallpapers/movies/kgf-kolar-gold-fields-chapter-1-ft-yash_1024-768.jpg"
        description="YouTube"
        title="KGF: Chapter 1"
        link="https://www.youtube.com/watch?v=ULEQb_l-N08&ab_channel=Goldmines"
      />
      <Card
        imgsrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR16MUgPQwJR7ad63ai4kSc1OLraqWFSkw0Pw&usqp=CAU"
        description="Amazon Prime Video"
        title="Toofaan"
        link="https://www.primevideo.com/dp/0Q3HPPCDAH413A40429QS3587D?ref_=dvm_pds_gen_in_as_s_gt_dsaallwebdmctest_mkw_s-dc&mrntrk=pcrid_569314977106_slid__pgrid_131556527415_pgeo_9300958_x__ptid_dsa-19959388920"
      />
      <Card
        imgsrc="https://cdn.gulte.com/wp-content/uploads/2021/07/Mimi-1.jpg"
        description="Jio Cinema Movie"
        title="Mimi"
        link="https://www.jiocinema.com/watch/movies/mimi/0/0/5f6c7660eac611eb901ec5c97a856714/0/0"
      />

      <Card
        imgsrc="https://qph.fs.quoracdn.net/main-qimg-6577490afb8a1c67a5942f3614c7ce7a"
        description="Hotstar Movie"
        title="Drishyam"
        link="https://www.hotstar.com/in/movies/drishyam/1000074189"
      />
      <Card
        imgsrc="https://otakukart.com/wp-content/uploads/2021/08/PIC-1-3.jpeg"
        description="Amazon Prime Video"
        title="Shershaah"
        link="https://www.primevideo.com/detail/Shershaah/0J3P7DO2UHT2IGF8UY24C2I94C"
      />

      <Card
        imgsrc="https://i0.wp.com/boxofficeworldwide.com/wp-content/uploads/2021/01/1170x658withlog_1586171401.jpg?fit=599%2C337&ssl=1"
        description="Zee5 Movie"
        title="Uri: The Surgical Strike"
        link="https://www.zee5.com/movies/details/watch-uri-the-surgical-strike-full-movie-online/0-0-33204"
      />
      <Card
        imgsrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqqjcHmeyuwWzJPDR4Z01GJM9c-yPRCDrABw&usqp=CAU"
        description="Hotstar Movie"
        title="Chhichhore"
        link="https://www.hotstar.com/gb/movies/chhichhore/1260012713"
      />
      <Card
        imgsrc="https://www.iwmbuzz.com/wp-content/uploads/2020/03/revealed-is-mirzapur-based-on-a-true-story-1024x576.jpg"
        description="Amazon Original series."
        title="Mirzapur"
        link="https://www.primevideo.com/detail/0FBF7DWFYG99Y3TSNVJ4ELOLBO/ref=atv_dp_season_select_s2"
      />
      <Card
        imgsrc="https://wallpapercave.com/wp/wp6075938.jpg"
        description="Amazon Original series"
        title="The Family Man"
        link="https://www.primevideo.com/detail/0S3QYI59BAEI5KVLHCKSR91YGD/ref=atv_sr_fle_c_Tn74RA_1_1_1?sr=1-1&pageTypeIdSource=ASIN&pageTypeId=B07X443FLN&qid=1642090209"
      />
      <Card
        imgsrc="https://akm-img-a-in.tosshub.com/indiatoday/images/video/201807/sacred_games.jpeg?FC07EzFKe1LQNx4MgEvnyyei.sQepZEY"
        description="Netfix Original series"
        title="Secret Game"
        link="https://www.netflix.com/in/title/80115328"
      />

      <Card
        imgsrc="https://www.readersfusion.com/wp-content/uploads/2018/10/Andhadhun-Movie-Cast.jpg"
        description="Jio Cinema Movie"
        title="Andhadhun"
        link="https://www.jiocinema.com/watch/movies/andhadhun/0/0/fefeb23024a111e99f690d39b2f2fb61/0/0"
      />
      <Card
        imgsrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThfkPz8e_pTSv7sgDk3Xw_eYNrJ7s0kHePCA&usqp=CAU"
        description="Amazon Original series"
        title="panchayat"
        link="https://www.primevideo.com/detail/0KEP4A6DWRKFYQFTSU5RXHEAN2/ref=atv_sr_fle_c_Tn74RA_1_1_1?sr=1-1&pageTypeIdSource=ASIN&pageTypeId=B085P19YHF&qid=1642089593"
      />
      <Card
        imgsrc="https://www.famousbollywood.com/wp-content/uploads/2021/03/criminal-justice-season-1-download-all-10-episodes.jpg"
        description="Hotstar Original series"
        title="Criminal Justice"
        link="https://www.hotstar.com/in/tv/criminal-justice/1260004267"
      />

      <Card
        imgsrc="https://i2.cinestaan.com/image-bank/1500-1500/172001-173000/172420.jpg"
        description="YouTube"
        title="Hera Pheri"
        link="https://www.youtube.com/watch?v=TIQ5hrfermg&ab_channel=GoldminesHindi"
      />
    </div>
  );
}

export default App;
